
import { GroupUserItemProps } from "apis/group-user";
import axios from "axios";
import { OutputBaseProps } from "utils/types/API";
import { ApiFormAccessControllAllOutputProps } from ".";
import { AccessControllDataItemProps } from "layouts/admin/pages/permission/AccessControll/FormAccessControll";

interface R1 { type: "form"; formId: number };
interface R2 { type: "step"; formId: number; stepId: number }
interface R3 { type: "status"; formId: number; statusId: number }
type ApiFormAccessControllGroupInputProps = R1 | R2 | R3;

type ApiFormAccessControllGroupOutputProps = OutputBaseProps<GroupUserItemProps[]>

export const apiFormAccessControllGroup = async (data: ApiFormAccessControllGroupInputProps) => {
    let url = "";
    switch (data.type) {
        case "form":
            url = `/api/form/${data.formId}/group/access-controll`;
            break;
        case "step":
            url = `/api/form/${data.formId}/step/${data.stepId}/group/access-controll`;
            break;
        case "status":
            url = `/api/form/${data.formId}/status/${data.statusId}/group/access-controll`;
            break;
        default:
            break;
    }
    const res = (await axios.get<ApiFormAccessControllGroupOutputProps>(url)).data;
    return res;
};


type ApiFormAccessControllGroupAllInputProps = { groupId: number }

type ApiFormAccessControllGroupAllOutputProps = ApiFormAccessControllAllOutputProps;

export const apiFormAccessControllGroupAll = async (data: ApiFormAccessControllGroupAllInputProps) => {
    const res = (await axios.get<ApiFormAccessControllGroupAllOutputProps>(`/api/form/access-controll/group/${data.groupId}`)).data;
    return res;
};

interface ApiFormAccessControllGroupAllUpdateInputProps {
    groupId: number;
    data: AccessControllDataItemProps[]
}
export const apiFormAccessControllGroupAllUpdate = async (data: ApiFormAccessControllGroupAllUpdateInputProps) => {
    const res = (await axios.put<ApiFormAccessControllGroupAllOutputProps>(`/api/form/access-controll/group/update/${data.groupId}`, data.data)).data;
    return res;
};